import React from 'react';
import './NFTModal.css';

function NFTModal({ nft, onClose }) {
  const traits = {
    background: nft.background,
    water: nft.water,
    skin: nft.skin,
    outline: nft.outline,
    shadows: nft.shadows,
    mouth: nft.mouth,
    eyes: nft.eyes,
    swag: nft.swag,
    pup: nft.pup,
    injury: nft.injury || 'None'
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        <div className="modal-grid">
          <div className="modal-image">
            <img src={nft.keyimage} alt={nft.capyid} />
          </div>
          <div className="modal-info">
            <div className="modal-header">
              <h2>{nft.capyid}</h2>
              <span className="modal-rarity">Rarity Score: {nft.rarityScore}%</span>
            </div>
            <div className="modal-traits">
              {Object.entries(traits).map(([trait, value]) => (
                <div key={trait} className="modal-trait">
                  <span className="trait-label">{trait.charAt(0).toUpperCase() + trait.slice(1)}:</span>
                  <span className="trait-value">{value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NFTModal;